import * as React from 'react';
import './HtmlPreview.sass';

type HtmlPreviewProps = {
  className: string;
  content: string;
};

const HtmlPreview = ({content, className}: HtmlPreviewProps) => {
  const blobParts = [content];
  const htmlFile = new Blob(blobParts, {type: 'text/html'});
  const htmlObjectUrl = URL.createObjectURL(htmlFile);

  return (
    <div className="html-preview">
      <iframe title="HTML Preview" className={className} src={htmlObjectUrl} />
    </div>
  );
};

export default HtmlPreview;
